import ImportCompoundPane from './ImportCompoundPane';

export default ImportCompoundPane;
